/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-styler .nav-pills{margin-bottom:8px;box-shadow:none}body.next-dark .menu-styler .tab-content{background:rgba(4,169,245,.03)}body.next-dark .menu-styler h1,body.next-dark .menu-styler h2,body.next-dark .menu-styler h3,body.next-dark .menu-styler h4,body.next-dark .menu-styler h5,body.next-dark .menu-styler h6,body.next-dark .menu-styler p{color:#222}"];
export { styles as styles };
